import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export const useConfig = () => useQuery({ queryKey: ["config"], queryFn: api.config, staleTime: Infinity });
export const useStats = () => useQuery({ queryKey: ["stats"], queryFn: api.stats, refetchInterval: 8000 });
export const useTokens = () => useQuery({ queryKey: ["tokens"], queryFn: api.tokens, refetchInterval: 10000 });
export const useDeals = (status = "open", address) =>
  useQuery({ queryKey: ["deals", status, address || null], queryFn: () => api.deals(status, address), refetchInterval: 4000, staleTime: 0 });
export const useDeal = (id) =>
  useQuery({ queryKey: ["deal", id], queryFn: () => api.deal(id), enabled: !!id, refetchInterval: 3000, staleTime: 0 });
export const useMessages = (id) =>
  useQuery({ queryKey: ["messages", id], queryFn: () => api.messages(id), enabled: !!id, refetchInterval: 3000, staleTime: 0 });
export const useSettled = () => useQuery({ queryKey: ["settled"], queryFn: api.settled, refetchInterval: 6000, staleTime: 0 });
export const useAlerts = (address) =>
  useQuery({ queryKey: ["alerts", address || null], queryFn: () => api.alerts(address), enabled: !!address, refetchInterval: 4000, staleTime: 0 });
